import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {src: String, interval: Number, reloadTimestamp: Number}

  connect() {
    if (!this.reloadTimestampValue) this.reloadTimestampValue = this.timestamp()
    this.beforeRender = this.stopIfIncomingOmitsController.bind(this)
    this.element.addEventListener("turbo:before-frame-render", this.beforeRender)
    this.timer = setInterval(this.tick.bind(this), 1000)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-frame-render", this.beforeRender)
    clearInterval(this.timer)
  }

  tick() {
    if (this.reloadTimestampValue + this.intervalValue <= this.timestamp()) this.reload()
  }

  reload() {
    if (!this.hasSrcValue) return

    if (!this.element.hasAttribute("src")) {
      this.element.setAttribute("refresh", "morph")
      this.element.setAttribute("src", this.srcValue) // eager replace. reload() cancels and morphs
    }

    this.element.reload()
    this.reloadTimestampValue = this.timestamp()
  }

  stopIfIncomingOmitsController(event) {
    if (event.target !== this.element) return

    const incoming = event.detail.newFrame
    if (!incoming) return
    if (incoming.matches("[data-controller~=turbo-frame-reloader]")) return

    this.element.removeAttribute("src")
    this.element.removeAttribute("refresh")
    this.element.removeAttribute("complete")
    this.element.removeAttribute("data-controller")
  }

  timestamp() {
    return Math.floor(Date.now() / 1000)
  }
}
